import React from 'react';
import $ from 'jquery';
var classNames = require('classnames');

export  class Button extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        this.props.onClick(this);
    }

    render() {
        if (this.props.bsStyle != undefined) {
            var style = 'btn btn-' + this.props.bsStyle;
        } else {
            var style = 'btn btn-default';
        }
        return (
            <button 
                disabled={this.props.disabled} 
                className={style} 
                type="button" 
                onClick={this.handleClick}
                style={{
                    margin: '0 5px',
                    minWidth: '80px',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    lineHeight: 'normal',
                    textAlign: 'center'
                }}
            >
                {this.props.icon && (
                    <i className="material-icons" style={{verticalAlign: 'middle', marginRight: '8px', marginTop: '2px', marginBottom: '2px', fontSize: '16px'}}>{this.props.icon}</i>
                )}
                <span style={{verticalAlign: 'middle', padding: '0 4px'}}>{this.props.value}</span>
            </button>
        );
    }
}


class Options extends React.Component {
    render() {
        return(
                this.props.values.map(function(options, i) {
                    return (<option key={i} value={options.value}>{options.text}</option>);
                }
            )
        )
    }
}

export  class Select extends React.Component {

    render() {
        if (this.props.values == undefined)
            return null;
        return (
            <select name={this.props.name} defaultValue={this.props.selected} className={this.props.className} onChange={this.props.onChange}>

                {
                    Object.keys(this.props.values).map(function(i) {
                        return (<option key={i} value={i}>{this.props.values[i]}</option>);
                    }, this)
                }
                </select>
        );
    }
}

export class Select2 extends React.Component {
    componentDidMount() {
        this.renderSelect2();
    }
    renderSelect2() {
        $('.select2_' + this.props.id).select2({
            multiple: 'multiple'
        });
    }
    render() {
        if (this.props.values == undefined)
            return null;
        var idclass = "select2_" + this.props.id;
        var parentClass = this.props.className;
        var selectClasses = classNames({
            [`select2_${this.props.id}`]: true,
            [`${this.props.className}`]: true
        });
        return (
            <select name={this.props.name} defaultValue={this.props.selected} className={selectClasses} multiple="true" onChange={this.props.onChange}>
                {
                    Object.keys(this.props.values).map(function(i) {
                        return (<option key={i} value={i}>{this.props.values[i]}</option>);
                    }, this)
                }
            </select>
        );
    }
}
